<template>
  <div style="margin-bottom: 15px">
    <v-card flat v-for="item in items">
      <v-layout style="padding-left: 8px">
        
        <!-- Optional icon on the left -->
        <div v-if="item.icon" style="min-width: 56px; display: flex">
          <!-- Tooltips! -->
          <v-tooltip v-if="item.tooltip" right style="margin: auto">
            <v-icon slot="activator" style="margin: auto; color: #d6684ec9">{{item.icon}}</v-icon>
            <span>{{item.tooltip}}</span>
          </v-tooltip>
          <v-icon v-else style="margin: auto">{{item.icon}}</v-icon>
          
        </div>

        <div> <!-- Title & subheading -->
          <v-card-title :style="titleStyle">
            <div class="subheading font-weight-regular" style="margin-bottom: 0">{{item.title}}</div>
          </v-card-title>
          <v-card-text :style="textStyle">
            <div style="color: rgba(0,0,0,0.54)">{{item.desc}}</div>
          </v-card-text>
        </div>

      </v-layout>
      <v-divider/>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'card-list',
  props: ['items', 'dense'],
  computed: {
    titleStyle() {
      return `padding-left: 8px; padding-bottom: 0; ${this.dense ? 'padding-top: 2px' : ''}`;
    },
    textStyle() {
      return `padding-left: 8px; padding-top: 0; text-align: left; ${this.dense ? 'padding-bottom: 2px' : ''}`
    },
  }
}
</script>

<style>

</style>
